export default "__VITE_ASSET__CiHHCLry__"